import { __assign, __read } from "tslib";
/**
 * @see https://github.com/NervJS/taro/blob/next/packages/taro-components/src/components/input/input.tsx
 */
import React, { useRef, useState } from "react";
import classNames from "classnames";
import { noop } from "../../../_util/noop";
import { useDefaultValue } from "../../../_util/use-default";
import { mergeRefs } from "../../../_util/merge-refs";
import { createEvent } from "../_util/create-event";
function getInputType(type, confirmType, password) {
    var inputType = type;
    if (typeof type === "undefined") {
        return "text";
    }
    if (!type) {
        throw new Error("unexpected type");
    }
    if (confirmType === "search") {
        inputType = "search";
    }
    if (password) {
        inputType = "password";
    }
    if (type === "digit") {
        inputType = "number";
    }
    return inputType;
}
export var Input = React.forwardRef(function Input(props, ref) {
    var _a = useDefaultValue(props, ""), type = _a.type, password = _a.password, _b = _a.confirmType, confirmType = _b === void 0 ? "done" : _b, _c = _a.maxlength, maxlength = _c === void 0 ? 140 : _c, value = _a.value, _d = _a.onInput, onInput = _d === void 0 ? noop : _d, _e = _a.onChange, onChange = _e === void 0 ? noop : _e, _f = _a.onFocus, onFocus = _f === void 0 ? noop : _f, _g = _a.onBlur, onBlur = _g === void 0 ? noop : _g, _h = _a.onKeyDown, onKeyDown = _h === void 0 ? noop : _h, _j = _a.onConfirm, onConfirm = _j === void 0 ? noop : _j, focus = _a.focus, _k = _a.autoFocus, autoFocus = _k === void 0 ? focus : _k, className = _a.className, style = _a.style, disabled = _a.disabled, placeholder = _a.placeholder, id = _a.id, name = _a.name;
    var inputType = getInputType(type, confirmType, password);
    var composingRef = useRef(false);
    // const inputExecutedRef = useRef(false);
    // 记录 `composition` 事件过程中值以实现受控
    var _l = __read(useState(""), 2), composingRefValue = _l[0], setComposingValue = _l[1];
    var inputProps = {
        id: id,
        name: name,
        disabled: disabled,
        placeholder: placeholder,
        autoFocus: autoFocus,
        type: inputType,
        maxLength: maxlength,
        value: composingRef.current ? composingRefValue : value,
        onChange: function (event) {
            event.stopPropagation();
            if (composingRef.current) {
                setComposingValue(event.currentTarget.value);
            }
            else {
                var value_1 = event.currentTarget.value;
                // number 类型 maxlength 无效
                if (inputType === "number" && value_1 && value_1.length >= maxlength) {
                    value_1 = value_1.substring(0, maxlength);
                    event.target.value = value_1;
                }
                onInput(createEvent(event, { value: value_1 }));
                onChange(event.currentTarget.value, { event: event });
            }
        },
        onInput: function (event) {
            event.stopPropagation();
        },
        onCompositionStart: function (event) {
            if (!event.target) {
                return;
            }
            composingRef.current = true;
        },
        onCompositionEnd: function (event) {
            if (!event.target) {
                return;
            }
            if (composingRef.current) {
                composingRef.current = false;
                onInput(createEvent(event, { value: event.currentTarget.value }));
                onChange(event.currentTarget.value, { event: event });
            }
            setComposingValue("");
        },
        onFocus: function (event) {
            onFocus(createEvent(event, { value: event.target.value }));
        },
        onBlur: function (event) {
            onBlur(createEvent(event, { value: event.target.value }));
        },
        onKeyDown: function (event) {
            event.stopPropagation();
            onKeyDown(event);
            if (event.key === "Enter") {
                onConfirm(createEvent(event, { value: event.currentTarget.value }));
            }
        },
    };
    return (React.createElement("div", { className: classNames(className), style: style },
        React.createElement("input", __assign({ className: "tea-core-input", ref: mergeRefs(ref, function (input) {
                if (autoFocus) {
                    input === null || input === void 0 ? void 0 : input.focus();
                }
            }) }, inputProps))));
});
//# sourceMappingURL=Input.js.map